export default __webpack_public_path__ + "static/mexico-9db6e704a9ed7f1452304d23ef4e3b15.svg";